import './libs/lazyLoad';
import './libs/logrocket';


import './scripts/header';
import './scripts/mobileNav';
// import './scripts/animations';
// import './scripts/search';

const responsiveBg = document.querySelector('.js-responsive-bg');
if (responsiveBg) {
    import('./scripts/responsiveBg').then(module => {
        module;
    });
}

const gFormHlds = document.querySelector('.gform_wrapper');
if (gFormHlds) {
    import('./scripts/gravityForms').then(module => {
        module;
    });
}

const hsFormHlds = document.querySelector('.hs-forms');
if (hsFormHlds) {
    import('./scripts/hubspotForms').then(module => {
        module;
    });
}

// const modal = document.querySelector('.js-modal-open');
// if (modal) {
//     import('./scripts/modals').then(module => {
//         module;
//     });
// }

// const accordions = document.querySelector('.js-hld-accordions');
// if (accordions) {
//     import('./scripts/accordions').then(module => {
//         module;
//     });
// }

// import './scripts/tabs';
// import './scripts/tableWrap';
// import './scripts/scrollTo';
